// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3_A2c","left":"styles_left__yp5WM","desktopActions":"styles_desktopActions__3O3Hv","title":"styles_title__2l0hZ"};